export interface AvatarPreset {
  id: string
  name: string
  emoji: string
  gradient: string
}

export const AVATAR_PRESETS: AvatarPreset[] = [
  {
    id: 'cyber-1',
    name: 'Cyber Samurai',
    emoji: '⚔️',
    gradient: 'from-cyan-500 to-blue-500',
  },
  {
    id: 'cyber-2',
    name: 'Neon Ninja',
    emoji: '🥷',
    gradient: 'from-purple-500 to-pink-500',
  },
  {
    id: 'cyber-3',
    name: 'Digital Ghost',
    emoji: '👻',
    gradient: 'from-green-500 to-cyan-500',
  },
  {
    id: 'cyber-4',
    name: 'Quantum Hacker',
    emoji: '💻',
    gradient: 'from-pink-500 to-orange-500',
  },
  {
    id: 'cyber-5',
    name: 'Neon Dragon',
    emoji: '🐉',
    gradient: 'from-red-500 to-purple-500',
  },
  {
    id: 'cyber-6',
    name: 'Circuit Warrior',
    emoji: '⚡',
    gradient: 'from-yellow-500 to-cyan-500',
  },
  {
    id: 'cyber-7',
    name: 'Data Phantom',
    emoji: '👾',
    gradient: 'from-indigo-500 to-purple-500',
  },
  {
    id: 'cyber-8',
    name: 'Void Walker',
    emoji: '🌌',
    gradient: 'from-gray-500 to-blue-500',
  },
  {
    id: 'cyber-9',
    name: 'Crypto Phoenix',
    emoji: '🔥',
    gradient: 'from-orange-500 to-red-500',
  },
  {
    id: 'cyber-10',
    name: 'Matrix Sentinel',
    emoji: '🤖',
    gradient: 'from-green-500 to-teal-500',
  },
  {
    id: 'cyber-11',
    name: 'Neon Viper',
    emoji: '🐍',
    gradient: 'from-lime-500 to-emerald-500',
  },
  {
    id: 'cyber-12',
    name: 'Tech Shaman',
    emoji: '🔮',
    gradient: 'from-violet-500 to-fuchsia-500',
  },
]
